import i18n from '@/config/i18n';

const { t } = i18n.global;

const getVisiblePropertiesText = (properties: Array<{ name: string }>): string => {
  const count = properties.length;
  let text;

  if (count === 1) {
    text = properties.map(({ name }) => name).join(', ');
  } else if (count > 1) {
    text = `${count} ${t('properties')}`;
  } else {
    text = t('Unassigned');
  }

  return text;
};

export default getVisiblePropertiesText;
